import { LeadsWorkspace } from "@/pages/sales/crm/page";

export default function SalesLeadsPage() {
  return <LeadsWorkspace mode="sales" />;
}
